import { createRouter, createWebHistory } from "vue-router";

import routes from "./routes.js"

import { checkAuth } from "./guard/index.js"

// console.log(process.env.BASE_URL)
// console.log(process)      // non funziona più
// console.log(import.meta.env.BASE_URL)
// console.log(import.meta)

window.popStateDetected = false
window.addEventListener('popstate', () => {
  if (window.popStateDetected == "justDenied") {
    window.popStateDetected = false
    console.log("popstate reset ", window.popStateDetected)
    return ''
  }
  window.popStateDetected = true
  console.log("popstate detected ", window.popStateDetected)
})



const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  routes,
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    // scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
});




router.beforeEach((to, from) => {
  // console.log(to)

  
  // if (IsItABackButton && from.meta.someLogica) {
  // if (
  //   window.popStateDetected &&
  //     (
  //     from.name === "root" ||
  //     to?.back === false
  //     )
  //   ) {
  //   window.popStateDetected = "justDenied"
  //   console.log("popstate reset ", window.popStateDetected)
  //   console.log("navigation denied by back button")
  //   next(false)
  //   return ''
  // }

  let auth = to?.meta?.auth

  const can_access_route = checkAuth(auth)

  if (can_access_route) {
    // console.log(auth)
    // console.log(to)
    console.log("🟢 access granted to " + to.path)
    return true;
  }
  else {
    console.log("🛑 access denied to " + to.path )
    return "login";
  }

  

});

export default router;




